var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "partner-logo"
  }, [_c("a-row", _vm._l(_vm.logoList, function (item, index) {
    return _c("a-col", {
      key: index,
      attrs: {
        span: 5
      }
    }, [_c("div", {
      staticClass: "img-wrapper"
    }, [_c("img", {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: require(`@/assets/images/logo/${item}`),
        expression: "require(`@/assets/images/logo/${item}`)"
      }],
      attrs: {
        alt: ""
      }
    })])]);
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };